import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Routes from "./Routes";

const App: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const dir = i18n.language?.startsWith("ar") ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language || "en";
  }, [i18n.language]);

  return <Routes />;
};

export default App;